
const it = {
  translation: {
    common: {
      password: 'Password',
      oldPassword: 'Vecchia Password',
      email: 'Email',
      requiredField: 'Campo obbligatorio',
      validEmail: 'Inserire email valida',
      january: 'gennaio',
      february: 'febbraio',
      march: 'marzo',
      april: 'aprile',
      may: 'maggio',
      june: 'giugno',
      july: 'luglio',
      august: 'agosto',
      september: 'settembre',
      october: 'ottobre',
      november: 'novembre',
      december: 'dicembre',
      numberValidation: 'Inserire un numero valido',
      confirm: 'Conferma',
      attention: 'Attenzione',
      modify: 'Modifica',
      congratulations: 'Congratulazioni!',
      textModalTitle: 'Inserisci testo',
      error: 'Errore',
      ok: 'Ok',
      cancel: 'Annulla',
      validationMinNumber: 'Inserire un numero maggiore di 0'

    },
    apiError: {
      'Request failed with status code 400': 'Controlla i campi che hai compilato e verifica che siano corretti!',
      'Request failed with status code 500': 'Si è verificato un errore nel server',
      'Request failed with status code 404': 'Elemento non trovato',
      'Request failed with status code 403': 'Utente non attivo',
      'Network Error': 'Errore di rete',
      service_not_available: 'Verificare i servizi aggiuntivi disponibili in questa data e riprovare',
      missing_check_in: 'Prima di fare il check-out è necessario fare il check-in',
      invalid_booking_status: 'Non si può eseguire questa operazione con la prenotazione in questo stato. Code error: invalid_booking_status',
      product_not_available: 'In questa data e in questi orari è già presente un evento confermato, modificare la prenotazione e poi riprovare',
      user_registration_email_already_registered: 'Utente già registrato. Se si è dimenticata la password è possibile richiedere il reset della password',
      user_change_password_old_wrong: 'La vecchia password non è corretta',
      wrong_date_format: 'Date incongruenti',
      error_generic_404: 'Elemento non trovato',
      error_generic_405: 'Si è verificato un errore.\nerror_generic_405',
      error_generic_400: 'Controlla i campi che hai compilato e verifica che siano corretti!',
      error_generic_500: 'Si è verificato un errore nel server, riprovare più tardi',
      room_not_available: 'Non è possibile confermare una prenotazione con un evento che va in conflitto con un evento già confermato in precedenza',
      invalid_date_value: 'Data non valida',
      error_generic: 'Si è verificato un errore, riprovare più tardi',
      general_internal_tb_error: "Si è verificato un errore nella piattaforma di monitoraggio",
      booking_is_not_confirmed: "Attenzione! Prenotazione non ancora confermata!",
      interval_check_in_already_done: "Non si può caricare il csv una volta che è stato impostato il check in",
      check_in_tb_error: 'Si è verificato un errore al checkin sulla piattaforma di monitoraggio',
      check_out_tb_error: 'Si è verificato un errore al checkout sulla piattaforma di monitoraggio',
      general_registration_tb_error: 'Si è verificato un errore alla registrazione sulla piattaforma di monitoraggio, ritenta la procedura effettuando il login',
      file_csv_list_attendees_exceeded: 'Il numero dei partecipanti caricati supera il numero dei partecipanti previsti',
      get_dashboard_link_tb_error: 'Si è verificato un errore durante l\'accesso alla piattaforma di monitoraggio',
      user_not_registered_tb_error: 'Utente non registrato sulla piattaforma di monitoraggio',
      booking_delete_failed: 'Attenzione! Non puoi cancellare una prenotazione che contiene eventi sui quali è stato effettutato il check-in',
      no_interval_found: 'In questa prenotazione non sono presenti eventi',
      invalid_remote_attendees_value: 'Numero di partecipanti da remoto non valido',
      invalid_check_in_out_range: 'Il check-in può essere effettuato massimo mezz\' ora prima dell\'orario di inizio dell\' evento e 5 minuti prima della fine',
      check_in_still_active: 'Un evento risulta essere ancora in check-in, effettuare il check-out per poter procedere',
      booking_interval_in_the_past: 'Non si può confermare una prenotazione con eventi nel passato, modifica la prenotazione per procedere',
      user_me_user_profile_related_name_does_not_exist: 'Si è verificato un errore, riprovare più tardi',
      missing_business_email_or_unique_code: 'Pec o codice univoco mancante',
      business_unique_code_invalid: 'il codice univoco deve essere di 6 o 7 caratteri',
    },
    login: {
      loginIntoYourAccount: 'Accedi alla tua area riservata',
      login: 'Accedi',
      loginWithGoogle: 'Accedi con google',
      loginWithFacebook: 'Accedi con facebook',
      loginWithSocial: 'o accedi con un social in cui sei registrato',
      signUp: 'Registrati',
      notSignUp: 'non sei ancora registrato? ',
      forgotPassword: 'Password dimenticata? ',
      forgotPasswordClick: 'Clicca qui '
    },
    registration: {
      firstName: 'Nome',
      lastName: 'Cognome',
      phoneNumber: 'Numero di telefono',
      confirmPassword: 'Conferma password',
      accept: 'Accetta ',
      privacy: 'l\'informativa sulla privacy',
      vatNumber: 'Partita iva',
      taxCode: 'Codice fiscale',
      businessName: 'Denominazione/ragione sociale',
      businessAddress: 'Indirizzo di fatturazione',
      businessUniqueCode: 'Codice univoco',
      businessEmail: 'Pec',
      signUp: 'Registrati',
      signUpEmail: 'Registrati con email',
      completeSignUp: 'Completa la tua registrazione',
      signupSocial: 'Registrati con il tuo social preferito',
      signupWithGoogle: 'Registrati con google',
      signupWithFacebook: 'Registrati con facebook',
      validNumber: 'Inserire un numero di telefono valido',
      passwordShort: 'La password deve contenere minimo 8 caratteri',
      passwordLong: 'La password è troppo lunga',
      passwordError: 'La password deve contenere almeno una maiuscola, una minuscola, un numero e un carattere speciale come ad esempio !"£$%&',
      confirmPasswordError: 'Le password non coincidono',
      changePassword: 'Cambia Password',
      registrationWithBookingTitle: 'Per completare la tua prenotazione è necessario registrarsi, una volta registrato, potrai visualizzare lo stato della tua prenotazione nella tua area personale',
      registrationComplete: 'La procedura di attivazione è in corso',
      registrationPasswordReset: 'Reset Password',
      resetPasswordSuccess: 'Ti abbiamo inviato un email all\'indirizzo da te indicato, segui le istruzione riportate',
      registrationConfirmed: 'Utenza attivata con successo, ora puoi accedere alla tua area riservata',
      registrationSuccess: 'Per completare la procedura di registrazione cliccare il link nella mail che ti abbiamo inviato',
      changePasswordSuccess: 'Password modificata con successo!',
      vatNumberValidation: 'La partita iva deve essere di 11 caratteri',
      taxCodeValidation: 'il codice fiscale deve essere di 16 caratteri',
      uniqueCodeValidation: 'il codice univoco deve essere di 6 o 7 caratteri',
      pecUniqueCodeValidation: 'Almeno un campo tra pec o codice univoco deve essere compilato',
    },
    booking: {
      titleEvent: 'Titolo',
      descriptionEvent: 'Descrizione',
      startHour: 'Ora inizio',
      endHour: 'Ora fine',
      participants: 'Partecipanti in presenza',
      online: 'Online',
      remote_participants: 'Partecipanti online',
      maxAttendeesValidation: 'Il numero di partecipanti supera il numero massimo',
      cashMethod: 'Pagamento in loco',
      bankTransfer: 'Bonifico',
      layoutRoom: 'Layout sala',
      addEvent: 'Aggiungi alla prenotazione',
      maxAttendees: 'Numero massimo {{participants}}',
      handleTools: 'Gestione attrezzatura',
      selectService: 'Scegli un servizio',
      selectLayout: 'Scegli un layout',
      handleReservation: 'Gestisci prenotazione',
      noSelectedDate: 'Nessuna data selezionata',
      selectedDate: 'Data selezionata',
      paymentMethod: 'Metodo di pagamento',
      timeValidation: 'Inserire ora inizio e ora fine',
      chooseRoom: 'Scegli la sala',
      selectServices: 'Seleziona servizi aggiuntivi',
      services: 'servizi',
      saveChanges: 'Salva modifiche',
      change: 'Modifica',
      book: 'Prenota',
      selectADate: 'Seleziona una data',
      errorValidationDate: 'E\' necessario selezionare una data',
      goToReservation: 'Gestisci prenotazione',
      reservationOwner: 'Richiedente prenotazione',
      reservationStatus: 'Stato prenotazione',
      descriptionEventResume: 'Evento del {{day}} dalle ore {{timeStart}} alle {{timeEnd}}, {{room}} con {{attendees}} partecipanti',
      notes: 'Note',
      bookButtonResume: 'Prenota',
      resume: 'Riepilogo',
      reservationSent: 'A breve riceverai conferma da parte del fornitore del servizio con la conferma della tua prenotazione.',
      reservationAdditionalMessage: 'Puoi verificare lo stato della tua prenotazione nella pagina "Le mie prenotazioni".',
      resumeReservation: 'Riepilogo prenotazione',
      events: '{{eventNum}} eventi aggiunti a questa prenotazione',
      eventErrorRoomClose: 'Non puoi prenotare in questo orario perchè le sale non sono aperte',
      eventErrorAlreadyBooked: 'La sala per questo slot è già stata prenotata',
      eventErrorBookOnPast: 'Non puoi prenotare una data nel passato',
      endBeforeStart: 'L\'orario di inizio deve essere antecedente all\'orario di fine',
      missingData: 'Dato mancante',
      searchLabelReservation: 'Cerca prenotazione',
      searchPlaceholderReservation: 'Cerca prenotazione per id, richiedente o email',
      modalErrorDate: 'Ricordati di selezionare una data!',
      eventDescriptionSmallCalendar: 'Evento del {{day}} dalle {{timeStart}} alle {{timeEnd}}',
      checkInTime: 'Check-in',
      successModalTitle: 'Richiesta inviata con successo!',
      sendReservation: 'Invia richiesta di prenotazione',
      sendUpdates: 'Invia modifiche',
      dateResume: 'data',
      timeResume: 'ora',
      room: 'Sala',
      inPresenceResume: 'in presenza',
      onlineResume: 'online',
      extraServicesResume: 'servizi extra',
      attendeesResume: 'invitati',
      timeStartEndResume: 'Dalle {{start}} alle {{end}}',
      titleTool: 'Gestione attrezzatura',
      standardTool: " - Standard: l'amministratore si occupa di lasciare i dispositivi scelti in prenotazione già accesi prima dell'inizio dell'evento. L'Organizzatore NON ha accesso alla piattaforma di monitoraggio",
      operatorTool: " - Operatore: un regista esterno (con un account apposito sulla piattaforma di monitoraggio) gestisce i dispositivi. Anche in questo caso l'Organizzatore NON ha accesso alla piattaforma di monitoraggio",
      selfServiceTool: "- Autonoma: l'Organizzatore ha accesso alla piattaforma di monitoraggio e gestisce a suo piacimento i dispositivi.",
      selectedDateEvent: 'Data selezionata',
      discard: 'Annulla',
      discardAlertMessage: 'Attenzione! Cliccando annulla tutte le modifiche andranno perse',
      deleteEvent: 'Sei sicuro di voler eliminare questo evento?',
      dateEvent: 'Data evento',
      selectEvent: 'Seleziona un evento'
    },
    bookingMobile: {
      bookedWhen: 'Prenotazione effettuata il:',
      bookingId: 'ID:',
      bookingStatus: 'Stato della prenotazione',
      eventsList: 'Lista eventi',
      attendees: 'partecipanti',
      dateTime: 'it-IT',
    },
    dashboard: {
      ourRoomsButtonName: 'Le nostre sale',
      bookingPageButtonName: 'Prenota sala',
      reservationListPagePageButtonName: 'Le mie prenotazioni',
      allEventsAdmin: 'Calendario Eventi',
      reservationsListAdmin: 'Lista prenotazioni',
      welcome: 'Ciao',
      eventsList: 'Lista eventi',
    },
    landing: {
      privateRoomsEvents: 'Uffici privati\nCoworking\nEventi',
      videoStreaming: 'Fino a 90 posti a sedere\nVideo wall\nEventi in streaming',
      bookYourRoom: 'Prenota la tua sala',
      onlyAvailableBooking: 'Si prega di notare che le sale sono disponibili alla prenotazione solo su richiesta.',
      privateArea: 'riservata',
      completeTheForm: 'Inserisci i dati degli eventi che vuoi realizzare nel calendario sottostante o accedi alla tua area ',
      bookingRooms: 'Accedi',
      login: 'Login',
      reserveNow: 'Accedi o registrati',
      landingText: 'Skyline Center',
      copyright: 'Copyright ©2024',
      services: 'Servizi',
      ourRooms: 'Le nostre sale',
      whereWeAre: 'Dove siamo',
      contacts: 'Contatti',
      titleDescriptionText: ' Cerchi il luogo perfetto per il tuo evento?',
      subtitleDescriptionText: ' La nostra location offre uno spazio versatile e accogliente per creare momenti memorabili. Che tu stia pianificando una conferenza, una presentazione, un meeting aziendale, siamo pronti a soddisfare le tue esigenze. Forniamo un’esperienza impeccabile per garantire il successo del tuo evento.',
      allianzAddress: 'P.za Antonio Segni, 1, 07100 Sassari',
      viewOnMaps: 'Visualizza su Google Maps',
      topHeroDescription: 'Connessione e professionalità per eventi che lasciano il segno',
      mixedAudioVideo: 'Mixed audio/video',
      liveStreaming: 'Live Streaming',
      wallLed: 'Wall Led',
      apeAndBuffet: 'Aperitivi e Buffet',
      ourServices: 'I nostri servizi',
      bookNow: 'Prenota ora',
      Recording: 'Registrazione',
      RecordingDesc: 'Servizio dedicato alla registrazione di eventi',
      LiveStreaming: 'Live Streaming',
      LiveStreamingDesc: 'Servizio dedicato alla trasmissione in tempo reale di eventi',
      Mixer: 'Mixer Audio, Luci, Video',
      MixerDesc: 'Fornitura e gestione di attrezzature audiovisive, inclusi mixer per audio, illuminazione e sistemi video',
      WallLed: 'Wall LED',
      WallLedDesc: 'Installazione e gestione di pareti a LED per visualizzazioni dinamiche e impatto visivo',
      BuffetAndApe: 'Buffet e Aperitivi',
      BuffetAndApeDesc: 'Offerta di buffet con varietà di piatti, inclusa la possibilità di servizio aperitivo o pranzo completo',
      WelcomeCoffee: 'Welcome Coffee',
      WelcomeCoffeeDesc: 'Servizio di caffè di benvenuto per gli ospiti, offrendo una selezione di bevande calde'

    },
    reservations: {
      resultsPage: 'risultati per pagina',
      labelDisplayedRows: 'elementi {{from}}-{{to}} su {{count}}',
      bookingOf: 'Prenotazione del {{day}}',
      booking: 'data prenotazione',
      status: 'stato',
      edit: 'modifica',
      extraInfoBooking: 'Evento del {{day}} dalle ore {{timeStart}} alle {{timeEnd}}, {{room}} con {{attendees}} partecipanti',
      myReservations: 'Le mie prenotazioni',
      subtitleReservationPage: 'In questa pagina è possibile gestire le tue prenotazioni e le liste degli invitati',
      sent: 'In attesa',
      confirmed: 'Confermata',
      canceledByUSer: 'cancellato dall\'utente',
      canceledByAdmin: 'cancellato dall\'admin',
      inProgress: 'In corso',
      completed: 'Completato',
      cancelRequested: 'cancellazione richiesta',
      reservationId: 'ID',
      nOfEvents: 'numero eventi',
      applicant: 'Richiedente',
      deleteReservationSuccess: 'Prenotazione cancellata con successo',
      date: 'data',
      time: 'ora',
      inPresence: 'in presenza',
      room: 'sala',
      online: 'online',
      services: 'servizi extra',
      attendeesList: 'lista invitati',
      timeStartEnd: 'Dalle {{start}} alle {{end}}',
      editCsv: 'Modifica',
      view: 'Vedi',
      add: 'Aggiungi',
      handleAttendees: 'Gestisci invitati',
      sendMessage: 'Invia messaggio',
      delete: 'Elimina',
      tools: 'Attrezzatura',
      addListAttendees: 'Aggiungi lista invitati',
      editListAttendees: 'Modifica lista invitati',
      uploadCsv: 'Carica il tuo documento in formato csv',
      uploadDocument: 'Carica documento ',
      dragAndDrop: ' o Drag & Drop qui',
      csvSuccessUpload: 'File CSV caricato con successo',
      loginToThingsboard: 'Accedi alla piattaforma di monitoraggio',
      overrideCsvUploadMessage: 'Attenzione i dati del csv precedentemente caricato andranno sovrascritti',
      noListUploaded: 'Nessuna lista caricata',
      logEventZoom: 'Accedi all\'evento',
      logEventZoomTitle: 'Accedi all\'evento zoom',
    },
    handleReservation: {
      reservationId: 'ID prenotazione',
      reservationStatus: 'Stato prenotazione',
      notes: 'Note inserite dal richiedente',
      applicant: 'Prenotazione a nome di',
      reservationDate: 'Data prenotazione',
      labelSearchReservation: 'Ricerca prenotazione',
      placeholderSearchReservation: 'Inserisci id prenotazione',
      confirmReservation: 'Conferma prenotazione',
      successConfirmMessage: 'Prenotazione confermata con successo',
      successCancelReservationMessage: 'Prenotazione cancellata con successo',
      adminNotesSuccess: 'Note aggiunte con successo',
      phoneNumber: 'Recapito telefonico: ',
      cancelReservation: 'Cancella prenotazione',
      cancelReservationWarning: 'Una volta cancellata la prenotazione non può essere riaperta, continuare?',
      confirmReservationWarning: 'Si sta confermando la prenotazione, è anche possibile (opzionalmente) inserire un messaggio aggiuntivo per il cliente qua sotto,  continuare?',
      descriptionEventResume: 'Evento del {{day}} dalle ore {{timeStart}} alle {{timeEnd}}, {{room}} con {{attendees}} partecipanti in presenza {{remote_attendees}}',
      checkIn: 'check-in: ',
      checkOut: 'check-out: ',
      selectDateTime: 'Seleziona data e ora',
      titleSelectDateTimeModal: 'Seleziona un orario per il ',
      sendCheckInOut: 'Invia',
      errorMessageDateTimeModal: 'Selezionare data e ora',
      titleEventsList: 'Eventi',
      checkInOutSuccess: '{{type}} avvenuto con successo!',
      paymentStatusSuccess: 'Stato del pagamento aggiornato!',
      paymentStatusAlert: 'Sei sicuro di voler modificare lo stato del pagamento?',
      addAdminNote: 'Aggiungi Note',
      adminNotes: 'Note inserite dall\'admin',
      messageAdminNotesModal: 'Inserisci eventuali note per la prenotazione',
      vatNumber: 'PARTITA IVA',
      taxCode: 'CODICE FISCALE',
      businessName: 'DENOMINAZIONE/RAGIONE SOCIALE',
      businessAddress: 'INDIRIZZO DI FATTURAZIONE',
      businessUniqueCode: 'CODICE UNIVOCO',
      reservationSummaryTitle: 'Riepilogo prenotazione',
      sendMessageToClaimant: 'Invia messaggio al richiedente',
      statusLabel: 'STATO',
      reservationIdLabel: 'ID PRENOTAZIONE',
      claimantLabel: 'RICHIEDENTE',
      reservationDateLabel: 'DATA PRENOTAZIONE',
      claimantPhoneLabel: 'RECAPITO TELEFONICO',
      claimantNotesLabel: 'NOTE DEL RICHIEDENTE',
      adminNotesLabel: 'NOTE DELL\'AMMINISTRATORE',
      eventListHeaderTitle: 'eventi in questa prenotazione',
      editReservation: 'Modifica prenotazione',
      deleteEventMessage: 'Potrai decidere di annullare l\'eliminazione di questo evento cliccando annulla, se invece si procederà con il salvataggio delle modifiche l\'evento sarà eliminato definitivamente',
      reservationSummaryDescriptionAlert: 'Attenzione, sono stati rimossi tutti gli eventi modificabili, procedere?',
      alertModalCHeckInOut: 'Sei sicuro di voler procedere?',
      businessEmail: 'PEC',
    },
    listAttendees: {
      eventDetailDay: 'Evento del {{day}}',
      eventDetailTime: 'Dalle {{eventStart}} alle {{eventEnd}}',
      numOfAttendees: 'Lista invitati ',
      nameAttendees: 'Nome e Cognome',
      presence: 'Presenza ({{presence}})',
      checkInAttendeesSuccess: 'Checkin avvenuto con successo',
      activeEvent: 'Evento attivo',
      attendeesPresence: 'Totale invitati da prenotazione: ',
      attendeesLoaded: 'Numero invitati importati da file csv: ',
      attendees: 'invitati',
      uploadCsv: 'Ricarica file csv con lista invitati',
      warningCsv: '  Attenzione hai caricato un numero inferiore di invitati rispetto a quanto indicato nella prenotazione',
      warningDuplicateNames: 'Ci sono alcuni nomi uguali, verifica che sia tutto ok!',
    },
    sendEmail: {
      emailSuccessMessage: 'Email inviata con successo!',
      titleEmail: 'Prenotazione del ',
      message: 'messaggio',
      insertMessage: 'Inserisci messaggio',
      send: 'Invia',
    },
    adminNewReservation: {
      dataCustomerTitle: 'Dati cliente richiedente la prenotazione',
      firstName: 'Nome',
      lastName: 'Cognome',
      phoneNumber: 'Numero di telefono',
      continue: 'Continua',
    },
    confirmResetPassword: {
      titlePage: 'Compila il form sottostante per completare la procedura di reset password',
      confirmResetPasswordSuccessMessage: 'Password modificata con successo',
      confirmPassword: 'Conferma password',
      changePassword: 'Cambia password',
    },
    editProfile: {
      titlePage: 'Compila i campi che vuoi modificare',
      phoneNumber: 'Numero di telefono',
      vatNumber: 'Partita iva',
      taxCode: 'Codice fiscale',
      businessName: 'Denominazion/ragione sociale',
      businessAddress: 'Indirizzo di fatturazione',
      businessUniqueCode: 'Codice univoco',
      edit: 'Salva modifiche',
      validNumber: 'Inserire un numero di telefono valido',
      editProfileSuccess: 'Modifiche avvenute con successo',
      vatNumberValidation: 'La partita iva deve essere di 11 caratteri',
      taxCodeValidation: 'il codice fiscale deve essere di 16 caratteri',
      uniqueCodeValidation: 'il codice univoco deve essere di 6 caratteri',
      businessEmail: 'Pec',
    },
    timePicker: {
      invalidHour: 'Orario non valido'
    },
    list: {
      showMore: 'mostra altro',
      active: 'Attivo',
    },
    roomsListPage: {
      title: 'Ciao {{name}}, benvenuto nella tua area privata!',
      subTitle: 'Scopri le nostre sale e prenota quella che preferisci. Potrai prenotare anche le due sale nella stessa prenotazione',
      bookNow: 'Prenota ora'
    },
    eventsList: {
      date: 'data',
      time: 'ora',
      reservation: 'prenotazione',
      organiser: 'organizzatore',
      payment: 'pagamento',
      eventStatus: 'stato',
      room: 'sala',
      inPresence: 'in presenza',
      online: 'online',
      paid: 'Pagato',
      notPaid: 'Non pagato',
      services: 'servizi',
      attendees: 'invitati',
      extraServices: 'servizi extra',
      checkIn: 'Check-in',
      checkOut: 'Check-out',
      remoteAttendeesZoomLimitMessage: `Attenzione il cliente ha richiesto più di 100 invitati online per questo evento`,
      id: 'id'
    },
    tbAlert: {
      title: 'Attenzione!',
      description: 'Il tuo account non risulta allineato con la piattaforma di monitoraggio',
      fix: 'Risolvi'
    }
  }
};

export { it };
